

 import React, { useEffect, useState, useRef, useCallback } from "react";
import { getAllAdminNews, getAllReporters, deleteNews, updateNews, uploadMediaFiles,updateNewsStatus  } from "../../../services/adminService";
import {
  CircularProgress,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Pagination,
  Stack,
  Select,
  MenuItem,
  TextField,
  FormControl,
  InputLabel,
  OutlinedInput,
  Chip,
  Box,
  IconButton,
  ListItem,
  List,
  ListItemText,
  Alert,
  Divider,
  ListItemIcon,Grid
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import CloseIcon from '@mui/icons-material/Close';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'; // PDF Icon
import { Editor } from '@tinymce/tinymce-react';

import {
  getCategories,
  getSubcategories,
  getCountries,
  getStatesByCountry,
  getCitiesByState,

} from '../../../services/apiService';
import LinkIcon from '@mui/icons-material/Link';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const RASHI_OPTIONS = [
  "Mesh", "Vrishabh", "Mithun", "Karka", "Singh", "Kanya",
  "Tula", "Vrischik", "Dhanu", "Makar", "Kumbh", "Meen"
];

const isValidUrl = (string) => {
  try {
    new URL(string);
    return true;
  } catch (e) {
    return false;
  }
};



const AllNewsManagement  = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewOpen, setViewOpen] = useState(false);
  const [selectedNews, setSelectedNews] = useState(null);
  const [statusUpdating, setStatusUpdating] = useState(null); 
  const [editOpen, setEditOpen] = useState(false);
  const [editFormData, setEditFormData] = useState({});
  const [newMediaFiles, setNewMediaFiles] = useState([]);
  const [existingMediaToKeep, setExistingMediaToKeep] = useState([]);
  const [mediaUrlInput, setMediaUrlInput] = useState('');
   const [filterCities, setFilterCities] = useState([]); 
   const [reportersDropdown, setReportersDropdown] = useState([]);
 const [filters, setFilters] = useState({
    status: 'pending_approval', 
    category: '',
    state: '',
    city: '',
    startDate: '',
    endDate: '',
    search: '',
  });
  // --- PDF specific states ---
  const [existingPdfFiles, setExistingPdfFiles] = useState([]); // To store PDF objects {url, originalName, _id}
  const [newPdfFiles, setNewPdfFiles] = useState([]);           // To store actual File objects for new PDF uploads
  const [pdfUrlInput, setPdfUrlInput] = useState('');           // For adding external PDF URLs
  // --- End PDF specific states ---

  const [formErrors, setFormErrors] = useState({});

  const [categoriesDropdown, setCategoriesDropdown] = useState([]);
  const [subCategoriesDropdown, setSubCategoriesDropdown] = useState([]);
  const [countriesDropdown, setCountriesDropdown] = useState([]);
  const [statesDropdown, setStatesDropdown] = useState([]);
  const [citiesDropdown, setCitiesDropdown] = useState([]);

  const [updateError, setUpdateError] = useState(null);
  const [updateSuccess, setUpdateSuccess] = useState(null);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [updating, setUpdating] = useState(false);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const editorRefEn = useRef(null);
  const editorRefHi = useRef(null);

    const clearFilters = () => {
    setFilters({
      status: 'posted',
      category: '',
      state: '',
      city: '',
      startDate: '',
      endDate: '',
      search: '',
      reporter: '', 
    });
    setPage(1);
  };

  const extractUrlsFromHtml = useCallback((htmlContent) => {
    const extracted = new Set();
    if (!htmlContent) return Array.from(extracted);

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');

    doc.querySelectorAll('img, video, source, iframe, a').forEach(el => {
      let url = el.getAttribute('src') || el.getAttribute('href');
      if (url && isValidUrl(url)) {
        extracted.add(url);
      }
    });

    doc.querySelectorAll('img').forEach(el => {
      const srcset = el.getAttribute('srcset');
      if (srcset) {
        srcset.split(',').forEach(srcPart => {
          const url = srcPart.trim().split(' ')[0];
          if (url && isValidUrl(url)) {
            extracted.add(url);
          }
        });
      }
    });

    doc.querySelectorAll('[data-mce-src]').forEach(el => {
      const dataMceSrc = el.getAttribute('data-mce-src');
      if (dataMceSrc && isValidUrl(dataMceSrc)) {
        extracted.add(dataMceSrc);
      }
    });

    doc.querySelectorAll('[data-mce-p-src]').forEach(el => {
      const dataMcePSrc = el.getAttribute('data-mce-p-src');
      if (dataMcePSrc && isValidUrl(dataMcePSrc)) {
        extracted.add(dataMcePSrc);
      }
    });
    return Array.from(extracted);
  }, []);

  const fetchMyNews = useCallback(async (pageNumber = page) => {
    try {
      setLoading(true);
      const response = await getAllAdminNews({ page: pageNumber, limit ,...filters});
      setNews(response.data || []);
      setTotalPages(response.totalPages ||response.pages || 1);
    } catch (error) {
      console.error("ERROR: Failed to load all news:", error);
    } finally {
      setLoading(false);
    }
  }, [limit, page,filters]);


  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
    setPage(1);
  };
useEffect(() => {
    const fetchInitialDropdownData = async () => {
      try {
        const [catsRes, countriesRes,reportersRes] = await Promise.all([
          getCategories(),
          getCountries(),
            getAllReporters()
        ]);
        setCategoriesDropdown(catsRes.data || []);
        setCountriesDropdown(countriesRes.data || []);
        setReportersDropdown(reportersRes.data || []);

        // Agar India (ya pehla desh) default hai, to uske states load kar lein filter ke liye
        if (countriesRes.data?.length > 0) {
           const res = await getStatesByCountry(countriesRes.data[0]._id);
           setStatesDropdown(res.data || []);
        }
      } catch (err) {
        console.error("ERROR: Initial load failed:", err);
      }
    };
    fetchInitialDropdownData();
  }, []);

   useEffect(() => {
    if (filters.state) {
      getCitiesByState(filters.state).then(res => setFilterCities(res.data || []));
    } else {
      setFilterCities([]);
    }
  }, [filters.state]);

  useEffect(() => {
    fetchMyNews(page);
  }, [fetchMyNews, page]);

  const headlineEditorConfig = {
    height: 180,
    menubar: false,
    branding: false,
    plugins: [
      'advlist', 'autolink', 'lists', 'link', 'charmap', 'preview', 
      'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen', 
      'insertdatetime', 'media', 'table', 'help', 'wordcount'
    ],

     // यह सुनिश्चित करेगा कि टेक्स्ट हमेशा <p> टैग में ही रहे
  forced_root_block: 'p',
  
  // अगर कोई बाहर से कलर या स्टाइल पेस्ट करे तो उसे हटा देगा
  paste_as_text: true, 
  invalid_styles: 'font-size font-family',
    // 'fontsizeselect' ही वो बटन है जिससे साइज बदलता है
    toolbar: 'undo redo | italic underline | fontsizeselect | forecolor backcolor | removeformat',
    
    // यहाँ हमने साइज की लिस्ट दे दी है ताकि आप बहुत बड़ा साइज भी चुन सकें
    fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 30pt 36pt 48pt 60pt 72pt 96pt',
    
    content_style: 'body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; font-size: 18px; }'
  };



  const editorConfig = {
    height: 500,
    menubar: true,
    branding: false,
    plugins: [
      'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
      'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
      'insertdatetime', 'media', 'table', 'help', 'wordcount', 'emoticons',
      'template', 'codesample', 'hr', 'pagebreak', 'nonbreaking',
      'toc', 'imagetools', 'textpattern', 'noneditable', 'quickbars',
      'accordion', 'autosave', 'save', 'directionality', 'visualchars'
    ],
    toolbar1: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify',
    toolbar2: 'outdent indent | numlist bullist | forecolor backcolor removeformat | charmap emoticons | fullscreen preview save print',
    toolbar3: 'insertfile image media link anchor | customupload | ltr rtl | showcomments addcomment',

    content_style: `
    body {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
      font-size: 14px;
      line-height: 1.6;
      margin: 1rem;
    }
    img { max-width: 100%; height: auto; }
    .mce-content-body {
      padding: 20px;
      max-width: none;
    }
  `,

    paste_data_images: true,
    automatic_uploads: true,
    file_picker_types: 'image media', // Note: TinyMCE's file_picker_types does not directly support 'application/pdf' without custom implementation

    file_picker_callback: function (callback, value, meta) {
      console.log('File picker triggered for:', meta.filetype);

      const input = document.createElement('input');
      input.setAttribute('type', 'file');

      if (meta.filetype === 'image') {
        input.setAttribute('accept', 'image/*');
      } else if (meta.filetype === 'media') {
        input.setAttribute('accept', 'video/*,audio/*');
      } else {
        input.setAttribute('accept', 'image/*,video/*,audio/*');
      }

      input.onchange = function () {
        const file = this.files[0];

        if (!file) {
          console.log('No file selected');
          return;
        }

        console.log('File selected:', file.name, file.type, file.size);

        const editor = window.tinymce.activeEditor;
        editor.setProgressState(true);

        const formData = new FormData();
        formData.append('mediaFiles', file); // Assuming uploadMediaFiles can handle various types

        uploadMediaFiles(formData)
          .then(response => {
            console.log('Upload response:', response);
            editor.setProgressState(false);

            if (response && response.locations && response.locations.length > 0) {
              const uploadedUrl = response.locations[0];
              console.log('File uploaded successfully:', uploadedUrl);

              // Add to existingMediaToKeep for general media URLs
              setExistingMediaToKeep(prev => {
                if (!prev.includes(uploadedUrl)) {
                  return [...prev, uploadedUrl];
                }
                return prev;
              });

              callback(uploadedUrl, {
                title: file.name,
                alt: file.name
              });

              editor.notificationManager.open({
                text: `File "${file.name}" uploaded successfully!`,
                type: 'success',
                timeout: 3000
              });
            } else {
              throw new Error('No URL returned from upload service');
            }
          })
          .catch(error => {
            console.error('Upload failed:', error);
            editor.setProgressState(false);

            editor.notificationManager.open({
              text: `Upload failed: ${error.message || 'Unknown error'}`,
              type: 'error',
              timeout: 5000
            });

            alert(`File upload failed: ${error.message || 'Please try again'}`);
          });
      };

      input.click();
    },

    images_upload_handler: function (blobInfo, success, failure, progress) {
      console.log('Image upload handler triggered');
      console.log('Blob info:', blobInfo.filename(), blobInfo.blob().type, blobInfo.blob().size);

      const blob = blobInfo.blob();

      const file = new File([blob], blobInfo.filename() || `image-${Date.now()}.png`, {
        type: blob.type || 'image/png'
      });

      console.log('Created file object:', file);

      const formData = new FormData();
      formData.append('mediaFiles', file);

      const editor = window.tinymce.activeEditor;
      editor.setProgressState(true);

      uploadMediaFiles(formData)
        .then(response => {
          console.log('Upload response:', response);
          editor.setProgressState(false);

          if (response && response.locations && response.locations.length > 0) {
            const uploadedUrl = response.locations[0];
            console.log('Image uploaded successfully:', uploadedUrl);

            setExistingMediaToKeep(prev => {
              if (!prev.includes(uploadedUrl)) {
                return [...prev, uploadedUrl];
              }
              return prev;
            });

            success(uploadedUrl);

            editor.notificationManager.open({
              text: `Image uploaded successfully!`,
              type: 'success',
              timeout: 3000
            });
          } else {
            throw new Error('No URL returned from upload service');
          }
        })
        .catch(error => {
          console.error('Image upload failed:', error);
          editor.setProgressState(false);

          failure(`Upload failed: ${error.message || 'Unknown error'}`);

          editor.notificationManager.open({
            text: `Upload failed: ${error.message || 'Unknown error'}`,
            type: 'error',
            timeout: 5000
          });
        });
    },

    setup: function (editor) {
      console.log('TinyMCE editor setup starting');

      editor.on('init', function () {
        console.log('TinyMCE editor initialized');
        editor.getContainer().style.transition = "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out";
      });

      editor.on('OpenWindow', (e) => {
        if (e.dialog.title === 'Insert/Edit Image' || e.dialog.title === 'Insert/Edit Media') {
          console.log('DEBUG: TinyMCE Image/Media Dialog opened. Inspecting "Source" field...');
          setTimeout(() => {
            const sourceInput = document.querySelector('.tox-dialog__body-content input[type="text"][aria-label="Source"]');
            const fallbackSourceInput = document.querySelector('.tox-textfield[name="src"]');

            const targetInput = sourceInput || fallbackSourceInput;

            if (targetInput) {
              console.log('DEBUG: Found TinyMCE "Source" input field programmatically.');
              if (targetInput.disabled) {
                console.warn('DEBUG: "Source" input is disabled. Attempting to re-enable.');
                targetInput.disabled = false;
                targetInput.setAttribute('aria-disabled', 'false');
              }
              if (targetInput.readOnly) {
                console.warn('DEBUG: "Source" input is readOnly. Attempting to remove readOnly.');
                targetInput.readOnly = false;
              }
              if (window.getComputedStyle(targetInput).pointerEvents === 'none') {
                console.warn('DEBUG: "Source" input has pointer-events: none. Attempting to set to auto.');
                targetInput.style.setProperty('pointer-events', 'auto', 'important');
              }

              setTimeout(() => {
                if (targetInput && !targetInput.disabled && !targetInput.readOnly && window.getComputedStyle(targetInput).pointerEvents !== 'none') {
                  targetInput.focus();
                  console.log('DEBUG: Attempted to focus the "Source" input field.');
                }
              }, 50);

            } else {
              console.log('DEBUG: TinyMCE "Source" input field not found in dialog using known selectors.');
            }
          }, 500);
        }
      });
      editor.ui.registry.addButton('customupload', {
        text: 'Upload Media',
        icon: 'upload',
        tooltip: 'Upload images or videos',
        onAction: function () {
          console.log('Custom upload button clicked');

          const input = document.createElement('input');
          input.setAttribute('type', 'file');
          input.setAttribute('accept', 'image/*,video/*,application/pdf'); // Added PDF to accept
          input.setAttribute('multiple', 'true');

          input.onchange = function () {
            const files = Array.from(this.files);
            console.log('Multiple files selected:', files.length);

            if (files.length === 0) return;

            editor.setProgressState(true);

            const formData = new FormData();
            files.forEach(file => {
              formData.append('mediaFiles', file);
              console.log('Adding file to FormData:', file.name);
            });

            uploadMediaFiles(formData)
              .then(response => {
                console.log('Batch upload response:', response);
                editor.setProgressState(false);

                if (response && response.locations && response.locations.length > 0) {
                    const newUrls = response.locations.filter(url => !existingMediaToKeep.includes(url));
                    setExistingMediaToKeep(prev => [...prev, ...newUrls]);

                    // Distribute files into TinyMCE content or pdf state based on type
                    response.locations.forEach((url, index) => {
                      const file = files[index];
                      if (file && file.type.startsWith('image/')) {
                        editor.insertContent(`<img src="${url}" alt="${file.name}" style="max-width: 100%; height: auto;" />`);
                      } else if (file && file.type.startsWith('video/')) {
                        editor.insertContent(`<video controls style="max-width: 100%; height: auto;">
                        <source src="${url}" type="${file.type}">
                        Your browser does not support the video tag.
                      </video>`);
                      } else if (file && file.type === 'application/pdf') {
                        // For PDFs, we add them to the specific PDF state
                        setExistingPdfFiles(prev => [...prev, { url, originalName: file.name }]);
                        editor.insertContent(`<p><a href="${url}" target="_blank">${file.name}</a></p>`); // Also insert a link into the editor
                      }
                    });

                  editor.notificationManager.open({
                    text: `Successfully uploaded ${response.locations.length} file(s)!`,
                    type: 'success',
                    timeout: 3000
                  });
                } else {
                  throw new Error('No URLs returned from upload service');
                }
              })
              .catch(error => {
                console.error('Batch upload failed:', error);
                editor.setProgressState(false);

                editor.notificationManager.open({
                  text: `Upload failed: ${error.message || 'Unknown error'}`,
                  type: 'error',
                  timeout: 5000
                });
              });
          };

          input.click();
        }
      });

      editor.on('drop', function (e) {
        console.log('File(s) dropped on editor');
      });

      editor.on('paste', function (e) {
        console.log('Content pasted into editor');
      });
    },

    contextmenu: 'link image table',
    quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
    quickbars_insert_toolbar: 'quickimage quicktable customupload',
    powerpaste_word_import: 'clean',
    powerpaste_html_import: 'clean',

    image_advtab: true,
    image_uploadtab: true,
    image_caption: true,
    image_title: true,

    formats: {
      alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'left' },
      aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'center' },
      alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'right' },
      alignjustify: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'full' },
      bold: { inline: 'strong' },
      italic: { inline: 'em' },
      underline: { inline: 'u' },
      strikethrough: { inline: 'del' },
      customformat: { inline: 'span', styles: { color: '#00ff00', fontSize: '20px' }, attributes: { title: 'My custom format' }, classes: 'example1' }
    }
  };


  useEffect(() => {
    const fetchInitialDropdownData = async () => {
      try {
        const [catsRes, countriesRes] = await Promise.all([
          getCategories(),
          getCountries(),
        ]);
        setCategoriesDropdown(catsRes.data || []);
        setCountriesDropdown(countriesRes.data || []);
      } catch (err) {
        console.error("ERROR: Failed to load initial dropdown data (categories/countries):", err);
      }
    };
    fetchInitialDropdownData();
    fetchMyNews();
  }, [limit, fetchMyNews]);


    // 2. Status update handler function
  const handleStatusUpdate = async (id, newStatus) => {
    try {
      setStatusUpdating(id); // Loading start
      await updateNewsStatus(id, newStatus);
      setUpdateSuccess(`News status changed to ${newStatus} successfully!`);
      fetchMyNews(page); // List refresh karein
    } catch (error) {
      console.error("Status Update Error:", error);
      setUpdateError("Failed to update status.");
    } finally {
      setStatusUpdating(null); // Loading stop
    }
  };

   const getStatusColor = (status) => {
    switch (status) {
      case 'posted': return 'success';
      case 'pending_approval': return 'warning';
      case 'rejected': return 'error';
      case 'draft': return 'default';
      default: return 'primary';
    }
  };
  const fetchSubcategoriesForEdit = useCallback(async (categoryId) => {
    if (categoryId) {
      try {
        const res = await getSubcategories(categoryId);
        setSubCategoriesDropdown(res.data || []);
      } catch (err) {
        console.error("ERROR: Failed to load subcategories for edit:", err);
        setSubCategoriesDropdown([]);
      }
    } else {
      setSubCategoriesDropdown([]);
    }
  }, []);

  const fetchStatesForEdit = useCallback(async (countryId) => {
    if (countryId) {
      try {
        const res = await getStatesByCountry(countryId);
        setStatesDropdown(res.data || []);
      } catch (err) {
        console.error("ERROR: Failed to load states for edit:", err);
        setStatesDropdown([]);
      }
    } else {
      setStatesDropdown([]);
    }
  }, []);

  const fetchCitiesForEdit = useCallback(async (stateId) => {
    if (stateId) {
      try {
        const res = await getCitiesByState(stateId);
        setCitiesDropdown(res.data || []);
      } catch (err) {
        console.error("ERROR: Failed to load cities for edit:", err);
        setCitiesDropdown([]);
      }
    } else {
      setCitiesDropdown([]);
    }
  }, []);


  const handleViewOpen = (item) => {
    setSelectedNews(item);
    setViewOpen(true);
  };

  const handleViewClose = () => {
    setViewOpen(false);
    setSelectedNews(null);
  };

  const handleEditOpen = async (item) => {
    console.log('DEBUG: handleEditOpen triggered for news item:', item._id);
    setSelectedNews(item);
    setUpdateError(null);
    setUpdateSuccess(null);
    setFormErrors({});

    await fetchSubcategoriesForEdit(item.category?._id);
    await fetchStatesForEdit(item.country?._id);
    await fetchCitiesForEdit(item.state?._id);

    setEditFormData({
      title_en: item.title_en || '',
      title_hi: item.title_hi || '',
      content_en: item.content_en || '',
      content_hi: item.content_hi || '',
      summary_en: item.summary_en || '',
      summary_hi: item.summary_hi || '',
      category: item.category?._id || '',
      subCategory: item.subCategory?._id || '',
      tags: item.tags || [],
      country: item.country?._id || '',
      state: item.state?._id || '',
      city: item.city?._id || '',
      localAddress: item.localAddress || '',
      status: item.status,
      subSubCategory: item.subSubCategory || '',
    });

    let initialMediaUrlsToKeep = new Set(item.media ? item.media.map(m => m.url) : []);

    if (item.mediaUrls && Array.isArray(item.mediaUrls)) {
        item.mediaUrls.forEach(url => initialMediaUrlsToKeep.add(url));
    }

    const urlsFromEnglishContent = extractUrlsFromHtml(item.content_en);
    const urlsFromHindiContent = extractUrlsFromHtml(item.content_hi);

    urlsFromEnglishContent.forEach(url => initialMediaUrlsToKeep.add(url));
    urlsFromHindiContent.forEach(url => initialMediaUrlsToKeep.add(url));

    setExistingMediaToKeep(Array.from(initialMediaUrlsToKeep));
    console.log("DEBUG: handleEditOpen: Initial existingMediaToKeep set to:", Array.from(initialMediaUrlsToKeep));

    // --- PDF specific initialization ---
    setExistingPdfFiles(item.pdfFiles || []);
    setNewPdfFiles([]);
    setPdfUrlInput('');
    // --- End PDF specific initialization ---

    setNewMediaFiles([]);
    setMediaUrlInput('');
    setEditOpen(true);
  };

  const handleEditClose = () => {
    console.log('DEBUG: handleEditClose triggered.');
    setEditOpen(false);
    setSelectedNews(null);
    setEditFormData({});
    setNewMediaFiles([]);
    setExistingMediaToKeep([]);
    setSubCategoriesDropdown([]);
    setStatesDropdown([]);
    setCitiesDropdown([]);
    setUpdateError(null);
    setUpdateSuccess(null);
    setMediaUrlInput('');
    setFormErrors({});
    // --- PDF specific reset ---
    setExistingPdfFiles([]);
    setNewPdfFiles([]);
    setPdfUrlInput('');
    // --- End PDF specific reset ---
  };

  const handleEditFormChange = async (e) => {
    const { name, value } = e.target;
    setEditFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setFormErrors((prev) => ({ ...prev, [name]: '' }));

    if (name === 'category') {
      setEditFormData((prevData) => ({ ...prevData, subCategory: '', subSubCategory: '' }));
      await fetchSubcategoriesForEdit(value);
    } else if (name === 'country') {
      setEditFormData((prevData) => ({ ...prevData, state: '', city: '' }));
      await fetchStatesForEdit(value);
    } else if (name === 'state') {
      setEditFormData((prevData) => ({ ...prevData, city: '' }));
      await fetchCitiesForEdit(value);
    }
  };

  const handleEditEditorChange = (content, editorName) => {
    setEditFormData((prevData) => ({
      ...prevData,
      [editorName]: content,
    }));
    setFormErrors((prev) => ({ ...prev, [editorName]: '' }));

    console.log('DEBUG: --- TinyMCE Editor Content Changed (onEditorChange) ---');
    console.log('DEBUG: Editor Name:', editorName);

    const extractedUrlsFromCurrentContent = extractUrlsFromHtml(content);

    setExistingMediaToKeep(prev => {
      const combinedUrls = new Set([...prev, ...extractedUrlsFromCurrentContent]);
      const finalUniqueUrls = Array.from(combinedUrls);
      return finalUniqueUrls;
    });
    console.log('DEBUG: --- End Editor Content Change ---');
  };

  const handleTagsChange = (e) => {
    const tagsArray = e.target.value.split(',').map(tag => tag.trim()).filter(tag => tag !== '');
    setEditFormData((prevData) => ({
      ...prevData,
      tags: tagsArray,
    }));
  };

  const handleNewMediaUpload = (e) => {
    console.log('DEBUG: handleNewMediaUpload triggered.');
    setNewMediaFiles(Array.from(e.target.files));
  };

  const handleRemoveExistingMedia = (urlToRemove) => {
    console.log('DEBUG: handleRemoveExistingMedia triggered for URL:', urlToRemove);
    setExistingMediaToKeep((prev) => prev.filter((url) => url !== urlToRemove));
  };

  const handleMediaUrlInputChange = (e) => {
    setMediaUrlInput(e.target.value);
    setFormErrors((prev) => ({ ...prev, mediaUrlInput: '' }));
  };

  const handleAddMediaUrl = () => {
    const url = mediaUrlInput.trim();
    if (url) {
      if (!isValidUrl(url)) {
        setFormErrors((prev) => ({ ...prev, mediaUrlInput: 'Please enter a valid URL.' }));
        return;
      }
      if (!existingMediaToKeep.includes(url)) {
        setExistingMediaToKeep(prev => [...prev, url]);
        setMediaUrlInput('');
      } else {
        setFormErrors((prev) => ({ ...prev, mediaUrlInput: 'This URL has already been added.' }));
      }
    }
  };

  // --- PDF specific handlers ---
  const handleNewPdfUpload = (e) => {
    setNewPdfFiles(Array.from(e.target.files));
  };

  const handleRemoveExistingPdf = (pdfToRemove) => {
    setExistingPdfFiles(prev => prev.filter(pdf => pdf._id !== pdfToRemove._id));
  };

  const handlePdfUrlInputChange = (e) => {
    setPdfUrlInput(e.target.value);
    setFormErrors((prev) => ({ ...prev, pdfUrlInput: '' }));
  };

  const handleAddPdfUrl = () => {
    const url = pdfUrlInput.trim();
    if (url) {
      if (!isValidUrl(url)) {
        setFormErrors((prev) => ({ ...prev, pdfUrlInput: 'Please enter a valid URL.' }));
        return;
      }
      // Check if URL already exists in either existingPdfFiles or newPdfFiles
      const isDuplicate = existingPdfFiles.some(pdf => pdf.url === url) ||
                         newPdfFiles.some(file => file.url === url); // Assuming newPdfFiles can store URLs if needed, but it's file objects currently
      if (!isDuplicate) {
        setExistingPdfFiles(prev => [...prev, { url, originalName: url.split('/').pop() || 'external_pdf' }]);
        setPdfUrlInput('');
      } else {
        setFormErrors((prev) => ({ ...prev, pdfUrlInput: 'This URL has already been added.' }));
      }
    }
  };
  // --- End PDF specific handlers ---


  const handleUpdateSubmit = async () => {
    if (!selectedNews) return;

    setUpdating(true);
    setUpdateError(null);
    setUpdateSuccess(null);
    setFormErrors({});

    let currentMediaUrls = [...existingMediaToKeep];
    const currentMediaUrlInputVal = mediaUrlInput.trim();
    if (currentMediaUrlInputVal) {
      if (!isValidUrl(currentMediaUrlInputVal)) {
        setFormErrors((prev) => ({ ...prev, mediaUrlInput: 'Please enter a valid URL.' }));
        setUpdating(false);
        setUpdateError("Please correct the errors in the form.");
        return;
      }
      if (!currentMediaUrls.includes(currentMediaUrlInputVal)) {
        currentMediaUrls.push(currentMediaUrlInputVal);
      } else {
        setFormErrors((prev) => ({ ...prev, mediaUrlInput: 'This URL has already been added.' }));
        setUpdating(false);
        setUpdateError("Please correct the errors in the form.");
        return;
      }
    }

    try {
      let finalMediaUrls = [...currentMediaUrls];
      let finalPdfFiles = [...existingPdfFiles]; // Start with existing PDFs

      if (newMediaFiles.length > 0) {
        console.log('DEBUG: Uploading new media files from dedicated button...');
        const formDataForNewFiles = new FormData();
        newMediaFiles.forEach(file => {
          formDataForNewFiles.append('mediaFiles', file);
        });
        const uploadResponse = await uploadMediaFiles(formDataForNewFiles);
        if (uploadResponse && uploadResponse.locations) {
          console.log('DEBUG: New media files uploaded, locations:', uploadResponse.locations);
          const uniqueNewUploadUrls = uploadResponse.locations.filter(url => !finalMediaUrls.includes(url));
          finalMediaUrls = [...finalMediaUrls, ...uniqueNewUploadUrls];
        } else {
          throw new Error('Failed to upload new media files.');
        }
      }

      // --- PDF upload logic ---
      if (newPdfFiles.length > 0) {
        console.log('DEBUG: Uploading new PDF files...');
        const formDataForNewPdfs = new FormData();
        newPdfFiles.forEach(file => {
          formDataForNewPdfs.append('mediaFiles', file); // Assuming the same endpoint
        });
        const uploadResponsePdfs = await uploadMediaFiles(formDataForNewPdfs);
        if (uploadResponsePdfs && uploadResponsePdfs.locations) {
          console.log('DEBUG: New PDF files uploaded, locations:', uploadResponsePdfs.locations);
          uploadResponsePdfs.locations.forEach((url, index) => {
            const file = newPdfFiles[index];
            finalPdfFiles.push({ url, originalName: file.name }); // Add new PDFs to the final array
          });
        } else {
          throw new Error('Failed to upload new PDF files.');
        }
      }

      // --- Handle external PDF URL input ---
      const currentPdfUrlInputVal = pdfUrlInput.trim();
      if (currentPdfUrlInputVal) {
        if (!isValidUrl(currentPdfUrlInputVal)) {
          setFormErrors((prev) => ({ ...prev, pdfUrlInput: 'Please enter a valid URL.' }));
          setUpdating(false);
          setUpdateError("Please correct the errors in the form.");
          return;
        }
        const isDuplicate = finalPdfFiles.some(pdf => pdf.url === currentPdfUrlInputVal);
        if (!isDuplicate) {
          finalPdfFiles.push({ url: currentPdfUrlInputVal, originalName: currentPdfUrlInputVal.split('/').pop() || 'external_pdf' });
        } else {
          setFormErrors((prev) => ({ ...prev, pdfUrlInput: 'This URL has already been added.' }));
          setUpdating(false);
          setUpdateError("Please correct the errors in the form.");
          return;
        }
      }
      // --- End PDF upload logic ---


      const formDataPayload = new FormData();

      Object.keys(editFormData).forEach(key => {
        if (key === 'tags') {
          formDataPayload.append(key, JSON.stringify(editFormData[key]));
        } else if (editFormData[key] !== undefined && editFormData[key] !== null) {
          formDataPayload.append(key, editFormData[key]);
        } else {
          formDataPayload.append(key, '');
        }
      });

      formDataPayload.append('mediaUrls', JSON.stringify(finalMediaUrls));
      formDataPayload.append('pdfFiles', JSON.stringify(finalPdfFiles)); // Append final PDF files array

      console.log("DEBUG: Submitting formDataPayload (for debug, cannot inspect FormData directly):");
      console.log("DEBUG:   title_en:", editFormData.title_en);
      console.log("DEBUG:   content_en length:", editFormData.content_en?.length);
      console.log("DEBUG:   finalMediaUrls (sent to backend):", finalMediaUrls);
      console.log("DEBUG:   finalPdfFiles (sent to backend):", finalPdfFiles);


      const response = await updateNews(selectedNews._id, formDataPayload);
      setUpdateSuccess(response.message || "News updated successfully!");
      handleEditClose();
      fetchMyNews(page);
    } catch (error) {
      console.error("ERROR: Failed to update news:", error);
      setUpdateError(error.response?.data?.message || error.message || "Failed to update news.");
    } finally {
      setUpdating(false);
    }
  };

  const handleDeleteClick = (item) => {
    setSelectedNews(item);
    setDeleteConfirmOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if (!selectedNews) return;
    try {
      setDeleting(true);
      await deleteNews(selectedNews._id);
      setDeleteConfirmOpen(false);
      setViewOpen(false);
      handleEditClose();
      fetchMyNews(page);
    } catch (error) {
      console.error("ERROR: Failed to delete news:", error);
    } finally {
      setDeleting(false);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteConfirmOpen(false);
    setSelectedNews(null);
  };

  const selectedCategoryName = categoriesDropdown.find(cat => cat._id === editFormData.category)?.name?.toLowerCase();
  const selectedSubCategoryName = subCategoriesDropdown.find(sub => sub._id === editFormData.subCategory)?.name?.toLowerCase();
  const showSubSubCategoryDropdown = selectedCategoryName === 'astrology' && selectedSubCategoryName === 'rashi';

  
  if (loading) {
    return (
      <div className="flex justify-center items-center mt-10">
        <CircularProgress />
      </div>
    );
  }

  return (

    
    <div className="p-4">
      <Typography variant="h5" gutterBottom>
        My News
      </Typography>


     <Paper sx={{ p: 2, mb: 3, backgroundColor: '#f5f7fa', borderRadius: 2 }}>
  <Grid container spacing={2} alignItems="center">

    {/* Reporter */}
    <Grid item xs={12} sm={6} md={2.4}>
      <FormControl fullWidth size="small">
        <InputLabel>Reporter</InputLabel>
        <Select
          name="reporter"
          value={filters.reporter || ""}
          label="Reporter"
          onChange={handleFilterChange}
        >
          <MenuItem value="">All Reporters</MenuItem>
          {reportersDropdown.map((rep) => (
            <MenuItem key={rep.id} value={rep.id}>
              {rep.name}{rep.city.name ? ` (${rep.city.name})` : ''}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>

    {/* Status */}
    <Grid item xs={12} sm={6} md={2.4}>
      <FormControl fullWidth size="small">
        <InputLabel>Status</InputLabel>
        <Select name="status" value={filters.status} label="Status" onChange={handleFilterChange}>
          <MenuItem value="all">All Status</MenuItem>
          <MenuItem value="pending_approval">Pending</MenuItem>
          <MenuItem value="posted">Posted</MenuItem>
          <MenuItem value="rejected">Rejected</MenuItem>
          <MenuItem value="draft">Draft</MenuItem>
        </Select>
      </FormControl>
    </Grid>

    {/* Category */}
    <Grid item xs={12} sm={6} md={2.4}>
      <FormControl fullWidth size="small">
        <InputLabel>Category</InputLabel>
        <Select name="category" value={filters.category} label="Category" onChange={handleFilterChange}>
          <MenuItem value="">All Categories</MenuItem>
          {categoriesDropdown.map((cat) => (
            <MenuItem key={cat._id} value={cat._id}>
              {cat.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>

    {/* State */}
    <Grid item xs={12} sm={6} md={2.4}>
      <FormControl fullWidth size="small">
        <InputLabel>State</InputLabel>
        <Select name="state" value={filters.state} label="State" onChange={handleFilterChange}>
          <MenuItem value="">All States</MenuItem>
          {statesDropdown.map((st) => (
            <MenuItem key={st._id} value={st._id}>
              {st.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>

    {/* City */}
    <Grid item xs={12} sm={6} md={2.4}>
      <FormControl fullWidth size="small" disabled={!filters.state}>
        <InputLabel>City</InputLabel>
        <Select name="city" value={filters.city} label="City" onChange={handleFilterChange}>
          <MenuItem value="">All Cities</MenuItem>
          {filterCities.map((ct) => (
            <MenuItem key={ct._id} value={ct._id}>
              {ct.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>

    {/* Start Date */}
    <Grid item xs={12} sm={6} md={3}>
      <TextField
        fullWidth
        size="small"
        type="date"
        label="From Date"
        name="startDate"
        InputLabelProps={{ shrink: true }}
        value={filters.startDate}
        onChange={handleFilterChange}
      />
    </Grid>

    {/* End Date */}
    <Grid item xs={12} sm={6} md={3}>
      <TextField
        fullWidth
        size="small"
        type="date"
        label="To Date"
        name="endDate"
        InputLabelProps={{ shrink: true }}
        value={filters.endDate}
        onChange={handleFilterChange}
      />
    </Grid>

    {/* Clear Button */}
    <Grid item xs={12} sm={6} md={3}>
      <Button
        fullWidth
        variant="outlined"
        color="secondary"
        onClick={clearFilters}
        startIcon={<ClearIcon />}
        sx={{ height: "40px" }}
      >
        Clear Filters
      </Button>
    </Grid>

  </Grid>
</Paper>


      {news.length === 0 ? (
        <Typography>No news found.</Typography>
      ) : (
        <>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                      <TableCell>#No</TableCell>
                  <TableCell>Image</TableCell>
                  <TableCell>Title (English)</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {news.map((item,index) => (
                  <TableRow key={item._id}>
                       <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      {item.media && item.media.length > 0 ? (
                        item.media[0].type === "video" ? (
                          <video
                            src={item.media[0].url}
                            width="90"
                            height="60"
                            controls={false}
                            autoPlay="true"
                            muted
                            loop
                            style={{
                              borderRadius: "8px",
                              objectFit: "cover",
                              backgroundColor: "#f0fdf9ff",
                            }}
                          />
                        ) : (
                          <img
                            src={item.media[0].url}
                            alt={item.media[0].caption || "News image"}
                            style={{
                              width: "90px",
                              maxHeight: "70px",
                              objectFit: "contain",
                              borderRadius: "8px",
                              backgroundColor: "#f0fdf9ff",
                            }}
                          />
                        )
                      ) : (
                        <Typography variant="caption" color="textSecondary">
                          No Media
                        </Typography>
                      )}
                    </TableCell>
                            <TableCell dangerouslySetInnerHTML={{ __html: item.title_hi || item.title_en }} />
                    {/* <TableCell>{item.title_en || item.title_hi}</TableCell> */}
                    <TableCell>{item.category?.name || "-"}</TableCell>
                    <TableCell>
                  <Chip 
                    label={item.status.toUpperCase()} 
                    color={getStatusColor(item.status)} 
                    size="small" 
                  />
                </TableCell>
                    <TableCell>
                   {item.createdBy.name} 
                  
                    </TableCell>


                    <TableCell align="center">
                  <Stack direction="row" spacing={1} justifyContent="center">
                    {item.status !== 'posted' && (
                      <Button
                        size="small"
                        variant="contained"
                        color="success"
                        disabled={statusUpdating === item._id}
                        onClick={() => handleStatusUpdate(item._id, 'posted')}
                      >
                        {statusUpdating === item._id ? '...' : 'Approve'}
                      </Button>
                    )}
                    
                    {item.status !== 'rejected' && (
                      <Button
                        size="small"
                        variant="contained"
                        color="error"
                        disabled={statusUpdating === item._id}
                        onClick={() => handleStatusUpdate(item._id, 'rejected')}
                      >
                        {statusUpdating === item._id ? '...' : 'Reject'}
                      </Button>
                    )}

                    {item.status === 'rejected' || item.status === 'posted' ? (
                        <Button
                          size="small"
                          variant="outlined"
                          disabled={statusUpdating === item._id}
                          onClick={() => handleStatusUpdate(item._id, 'pending_approval')}
                        >
                          Reset to Pending
                        </Button>
                    ) : null}
                  </Stack>
                </TableCell>

                    <TableCell align="center">
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => handleViewOpen(item)}
                        sx={{ mr: 1 }}
                      >
                        View
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        color="primary"
                        onClick={() => handleEditOpen(item)}
                        sx={{ mr: 1 }}
                      >
                        Edit
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        color="error"
                        onClick={() => handleDeleteClick(item)}
                      >
                        Delete
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>


          </TableContainer>
          <Stack spacing={2} sx={{ mt: 2 }} alignItems="center">
            <Pagination
              count={totalPages}
              page={page}
              onChange={(e, value) => setPage(value)}
              color="primary"
            />
            <Select
              value={limit}
              onChange={(e) => {
                setLimit(e.target.value);
                fetchMyNews(1);
              }}
            >
              {[5, 10, 20, 50].map((l) => (
                <MenuItem key={l} value={l}>
                  {l} per page
                </MenuItem>
              ))}
            </Select>
          </Stack>
        </>
      )}

      <Dialog open={viewOpen} onClose={handleViewClose} fullWidth maxWidth="md">
        <DialogTitle>News Details</DialogTitle>
        <DialogContent dividers>
          {selectedNews?.media && selectedNews?.media.length > 0 && (
            <img
              src={selectedNews.media[0].url}
              alt={selectedNews.media[0].caption || "News image"}
              style={{
                width: "100%",
                maxHeight: "300px",
                objectFit: "contain",
                borderRadius: "8px",
                marginBottom: "16px",
                backgroundColor: "#f0fdf9ff",
              }}
            />
          )}

          <Typography variant="h6" gutterBottom><strong>Title (English):</strong> {selectedNews?.title_en || "-"}</Typography>
          {/* <Typography variant="h6" gutterBottom><strong>शीर्षक (हिंदी):</strong> {selectedNews?.title_hi || "-"}</Typography> */}
<Typography variant="h6" gutterBottom>
  <strong>शीर्षक (हिंदी): </strong><span
dangerouslySetInnerHTML={{
      __html: selectedNews?.title_hi || "-"
    }}
  />
</Typography>


          <Typography variant="subtitle1" gutterBottom><strong>Summary (English):</strong> {selectedNews?.summary_en || "-"}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>सारांश (हिंदी):</strong> {selectedNews?.summary_hi || "-"}</Typography>

          <Typography variant="subtitle1" gutterBottom><strong>Category:</strong> {selectedNews?.category?.name || "-"}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>Sub Category:</strong> {selectedNews?.subCategory?.name || "-"}</Typography>
          {selectedNews?.subSubCategory && (
            <Typography variant="subtitle1" gutterBottom><strong>Sub-Sub Category (Rashi):</strong> {selectedNews.subSubCategory}</Typography>
          )}
          <Typography variant="subtitle1" gutterBottom><strong>Status:</strong> {selectedNews?.status}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>Country:</strong> {selectedNews?.country?.name || "-"}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>State:</strong> {selectedNews?.state?.name || "-"}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>City:</strong> {selectedNews?.city?.name || "-"}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>Local Address:</strong> {selectedNews?.localAddress || "-"}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>Reporter:</strong> {selectedNews?.createdBy?.name || "-"} / ({selectedNews?.createdBy?.email})</Typography>

          <Typography variant="subtitle2" gutterBottom><strong>Posted Date:</strong> {selectedNews?.postedDate || "N/A"} {selectedNews?.postedTime || "N/A"}</Typography>
          <Typography variant="subtitle2" gutterBottom><strong>Last Updated:</strong> {selectedNews?.updatedAtDate} {selectedNews?.updatedAtTime}</Typography>

          <Typography variant="body1" sx={{ mt: 2 }}>
            <strong>Content (English):</strong>
            <br />
            <div dangerouslySetInnerHTML={{ __html: selectedNews?.content_en || "No English content available" }} />
          </Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            <strong>सामग्री (हिंदी):</strong>
            <br />
            <div dangerouslySetInnerHTML={{ __html: selectedNews?.content_hi || "कोई हिंदी सामग्री उपलब्ध नहीं है" }} />
          </Typography>

          {selectedNews?.tags?.length > 0 && (
            <Typography variant="subtitle1" sx={{ mt: 2 }}>
              <strong>Tags:</strong> {selectedNews.tags.join(", ")}
            </Typography>
          )}
          {selectedNews?.referenceLinks?.length > 0 && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle1"><strong>Reference Links:</strong></Typography>
              <List dense>
                {selectedNews.referenceLinks.map((link, index) => (
                  <ListItem key={index} disablePadding>
                    <ListItemText primary={<a href={link} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>{link}</a>} />
                  </ListItem>
                ))}
              </List>
            </Box>
          )}
          {selectedNews?.mediaUrls?.length > 0 && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle1"><strong>External Media URLs:</strong></Typography>
              <List dense>
                {selectedNews.mediaUrls.map((url, index) => (
                  <ListItem key={index} disablePadding>
                    <ListItemText primary={<a href={url} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>{url}</a>} />
                  </ListItem>
                ))}
              </List>
            </Box>
          )}
          {selectedNews?.pdfFiles?.length > 0 && ( // Display PDF Files in View Modal
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle1"><strong>PDF Files:</strong></Typography>
              <List dense>
                {selectedNews.pdfFiles.map((pdf, index) => (
                  <ListItem key={pdf._id || index} disablePadding>
                    <ListItemIcon><PictureAsPdfIcon /></ListItemIcon>
                    <ListItemText primary={<a href={pdf.url} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>{pdf.originalName || pdf.url.split('/').pop()}</a>} />
                  </ListItem>
                ))}
              </List>
            </Box>
          )}
          <Typography variant="subtitle2" sx={{ mt: 2 }}>
            <strong>Views:</strong> {selectedNews?.viewsCount || 0}
          </Typography>
          <Typography variant="subtitle2">
            <strong>Likes:</strong> {selectedNews?.likesCount || 0}
          </Typography>
          <Typography variant="subtitle2">
            <strong>Comments:</strong> {selectedNews?.commentsCount || 0}
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleViewClose} variant="contained" color="primary">
            Close
          </Button>
          <Button
            onClick={() => handleDeleteClick(selectedNews)}
            variant="contained"
            color="error"
          >
            Delete
          </Button>

        </DialogActions>
      </Dialog>

      <Dialog open={editOpen} onClose={handleEditClose} fullWidth maxWidth="md" disableEnforceFocus={true}>
        {/* <DialogTitle>
          Edit News: {selectedNews?.title_en || selectedNews?.title_hi}
        </DialogTitle> */}

        <DialogTitle>
  Edit News:{" "}
  <span
    dangerouslySetInnerHTML={{
      __html: selectedNews?.title_en || selectedNews?.title_hi || "-"
    }}
  />
</DialogTitle>


        <DialogContent dividers>
          {updateError && <Alert severity="error" sx={{ mb: 2 }}>{updateError}</Alert>}
          {updateSuccess && <Alert severity="success" sx={{ mb: 2 }}>{updateSuccess}</Alert>}


          <Box
  sx={{
  
    border: formErrors.title_en ? "1px solid red" : "1px solid #ccc",
    borderRadius: 1,
    mb: 2,
      
  }}
>
   <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 1 }}>
              Title (English) *
            </Typography>
  <Editor
    apiKey="tdqbnxhth99nqmhdy4dmearws4a1teixkl1220nwcnxwhro9"
    init={headlineEditorConfig}
    value={editFormData.title_en || ""}
    onEditorChange={(content) =>
      setEditFormData((prev) => ({
        ...prev,
        title_en: content,
      }))
    }
  />
</Box>

{formErrors.title_en && (
  <Typography color="error" variant="caption">
    {formErrors.title_en}
  </Typography>
)}

<Box
  sx={{
    border: formErrors.title_hi ? "1px solid red" : "1px solid #ccc",
    borderRadius: 1,
    mb: 2,
  }}
>
  <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 1 }}>
              Title (Hindi) *
            </Typography>
  <Editor
    apiKey="tdqbnxhth99nqmhdy4dmearws4a1teixkl1220nwcnxwhro9"
    init={headlineEditorConfig}
    value={editFormData.title_hi || ""}
    onEditorChange={(content) =>
      setEditFormData((prev) => ({
        ...prev,
        title_hi: content,
      }))
    }
  />
</Box>

{formErrors.title_hi && (
  <Typography color="error" variant="caption">
    {formErrors.title_hi}
  </Typography>
)}


          {/* <TextField
            margin="dense"
            name="title_en"
            label="Title (English)"
            type="text"
            fullWidth
            variant="outlined"
            value={editFormData.title_en || ""}
            onChange={handleEditFormChange}
            sx={{ mb: 2 }}
            error={!!formErrors.title_en}
            helperText={formErrors.title_en}
          />
          <TextField
            margin="dense"
            name="title_hi"
            label="शीर्षक (हिंदी)"
            type="text"
            fullWidth
            variant="outlined"
            value={editFormData.title_hi || ""}
            onChange={handleEditFormChange}
            sx={{ mb: 2 }}
            error={!!formErrors.title_hi}
            helperText={formErrors.title_hi}
          /> */}
          <TextField
            margin="dense"
            name="summary_en"
            label="Summary (English)"
            type="text"
            fullWidth
            multiline
            rows={2}
            variant="outlined"
            value={editFormData.summary_en || ""}
            onChange={handleEditFormChange}
            sx={{ mb: 2 }}
            error={!!formErrors.summary_en}
            helperText={formErrors.summary_en}
          />
          <TextField
            margin="dense"
            name="summary_hi"
            label="सारांश (हिंदी)"
            type="text"
            fullWidth
            multiline
            rows={2}
            variant="outlined"
            value={editFormData.summary_hi || ""}
            onChange={handleEditFormChange}
            sx={{ mb: 2 }}
            error={!!formErrors.summary_hi}
            helperText={formErrors.summary_hi}
          />

          <Box sx={{ mt: 3, mb: 3 }}>
            <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 1 }}>
              Content (English) *
            </Typography>
            <Box sx={{ border: formErrors.content_en ? '1px solid #f44336' : '1px solid #e0e0e0', borderRadius: 1 }}>
              <Editor
                apiKey="tdqbnxhth99nqmhdy4dmearws4a1teixkl1220nwcnxwhro9"
                onInit={(evt, editor) => editorRefEn.current = editor}
                init={editorConfig}
                value={editFormData.content_en}
                onEditorChange={(content) => handleEditEditorChange(content, 'content_en')}
              />
            </Box>
            {formErrors.content_en && (
              <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
                {formErrors.content_en}
              </Typography>
            )}
          </Box>
          <Divider sx={{ my: 2 }} />

          <Box sx={{ mt: 3, mb: 3 }}>
            <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 1 }}>
              सामग्री (हिंदी) * 
            </Typography>
            <Box sx={{ border: formErrors.content_hi ? '1px solid #f44336' : '1px solid #e0e0e0', borderRadius: 1 }}>
              <Editor
                apiKey="tdqbnxhth99nqmhdy4dmearws4a1teixkl1220nwcnxwhro9"
                onInit={(evt, editor) => editorRefHi.current = editor}
                init={editorConfig}
                value={editFormData.content_hi}
                onEditorChange={(content) => handleEditEditorChange(content, 'content_hi')}
              />
            </Box>
            {formErrors.content_hi && (
              <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
                {formErrors.content_hi}
              </Typography>
            )}
          </Box>
          <Divider sx={{ my: 2 }} />

          <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
            <InputLabel id="category-select-label">Category</InputLabel>
            <Select
              labelId="category-select-label"
              name="category"
              value={editFormData.category || ''}
              label="Category"
              onChange={handleEditFormChange}
              error={!!formErrors.category}
            >
              <MenuItem value="">Select Category</MenuItem>
              {categoriesDropdown.map((cat) => (
                <MenuItem key={cat._id} value={cat._id}>
                  {cat.name}
                </MenuItem>
              ))}
            </Select>
            {formErrors.category && (
              <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
                {formErrors.category}
              </Typography>
            )}
          </FormControl>

          <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
            <InputLabel id="subcategory-select-label">Sub Category</InputLabel>
            <Select
              labelId="subcategory-select-label"
              name="subCategory"
              value={editFormData.subCategory || ''}
              label="Sub Category"
              onChange={handleEditFormChange}
              disabled={!editFormData.category || subCategoriesDropdown.length === 0}
            >
              <MenuItem value="">Select Sub Category (Optional)</MenuItem>
              {subCategoriesDropdown.map((subCat) => (
                <MenuItem key={subCat._id} value={subCat._id}>
                  {subCat.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {showSubSubCategoryDropdown && (
            <TextField
              label="Select Rashi (subSubCategory)"
              name="subSubCategory"
              select
              fullWidth
              margin="normal"
              value={editFormData.subSubCategory}
              onChange={handleEditFormChange}
              sx={{ mb: 2 }}
            >
              <MenuItem value="">Select Rashi</MenuItem>
              {RASHI_OPTIONS.map(r => (
                <MenuItem key={r} value={r}>{r}</MenuItem>
              ))}
            </TextField>
          )}

          <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
            <InputLabel htmlFor="news-tags">Tags (comma separated)</InputLabel>
            <OutlinedInput
              id="news-tags"
              name="tags"
              value={editFormData.tags?.join(', ') || ""}
              onChange={handleTagsChange}
              label="Tags (comma separated)"
            />
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
              {editFormData.tags?.map((tag, index) => (
                <Chip key={index} label={tag} />
              ))}
            </Box>
          </FormControl>

          <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
            <InputLabel id="country-select-label">Country</InputLabel>
            <Select
              labelId="country-select-label"
              name="country"
              value={editFormData.country || ''}
              label="Country"
              onChange={handleEditFormChange}
            >
              <MenuItem value="">Select Country (Optional)</MenuItem>
              {countriesDropdown.map((country) => (
                <MenuItem key={country._id} value={country._id}>
                  {country.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
            <InputLabel id="state-select-label">State</InputLabel>
            <Select
              labelId="state-select-label"
              name="state"
              value={editFormData.state || ''}
              label="State"
              onChange={handleEditFormChange}
              disabled={!editFormData.country || statesDropdown.length === 0}
            >
              <MenuItem value="">Select State (Optional)</MenuItem>
              {statesDropdown.map((state) => (
                <MenuItem key={state._id} value={state._id}>
                  {state.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Enhanced Media Section */}
          <Box sx={{ my: 3 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
              Media Files & External URLs
            </Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 2 }}>
              Upload new images/videos or add external media URLs. TinyMCE में uploaded media automatically यहां add हो जाएगा।
            </Typography>

            {/* File Upload Button for Images/Videos */}
            <Button
              variant="outlined"
              component="label"
              fullWidth
              startIcon={<AddCircleOutlineIcon />}
              sx={{ mb: 2, py: 1.5 }}
              disabled={updating}
            >
              Upload Images/Videos
              <input
                type="file"
                hidden
                onChange={handleNewMediaUpload}
                multiple
                accept="image/*,video/*"
              />
            </Button>

            {/* New Files Preview (Images/Videos) */}
            {newMediaFiles.length > 0 && (
              <Box sx={{ mt: 2, mb: 2 }}>
                <Typography variant="subtitle2" gutterBottom>New Images/Videos to Upload:</Typography>
                <List dense sx={{ bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                  {newMediaFiles.map((file) => (
                    <ListItem
                      key={file.name + file.size}
                      secondaryAction={
                        <IconButton edge="end" aria-label="delete" onClick={() => {
                          setNewMediaFiles(prev => prev.filter(f => f !== file));
                        }}>
                          <CloseIcon />
                        </IconButton>
                      }
                    >
                      <ListItemIcon>
                        {file.type.startsWith('image/') ? <ImageOutlinedIcon color="primary" /> : <VideoFileIcon color="secondary" />}
                      </ListItemIcon>
                      <ListItemText
                        primary={file.name}
                        secondary={`${(file.size / 1024 / 1024).toFixed(2)} MB (${file.type})`}
                      />
                    </ListItem>
                  ))}
                </List>
              </Box>
            )}

            {/* External URL Input for Images/Videos */}
            {/* <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
              <TextField
                label="Add External Media URL (YouTube, Image, Video)"
                value={mediaUrlInput}
                onChange={handleMediaUrlInputChange}
                fullWidth
                placeholder="https://example.com/image.jpg"
                error={!!formErrors.mediaUrlInput}
                helperText={formErrors.mediaUrlInput}
                disabled={updating}
              />
              <IconButton
                color="primary"
                onClick={handleAddMediaUrl}
                disabled={!mediaUrlInput.trim() || updating}
                sx={{
                  border: '1px solid',
                  borderColor: 'primary.main',
                  borderRadius: 1
                }}
              >
                <AddCircleOutlineIcon />
              </IconButton>
            </Box> */}

            {/* Existing Media Display (Images/Videos) */}
            {/* {existingMediaToKeep.length > 0 && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2" gutterBottom>Current Images/Videos ({existingMediaToKeep.length}):</Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 1 }}>
                  {existingMediaToKeep.map((url, index) => {
                    const isImage = /\.(jpeg|jpg|gif|png|webp|svg)\b/i.test(url.split('?')[0]);
                    const isVideo = /\.(mp4|webm|ogg)\b/i.test(url.split('?')[0]) || url.includes('youtube.com') || url.includes('vimeo.com');
                    const isLink = !isImage && !isVideo;

                    return (
                      <Box key={url} sx={{
                          position: 'relative',
                          width: '100px',
                          height: '100px',
                          border: '1px solid #ccc',
                          borderRadius: '4px',
                          overflow: 'hidden',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#f5f5f5',
                          flexDirection: 'column',
                          padding: '5px'
                      }}>
                        {isImage && (
                          <img
                            src={url}
                            alt={`Media ${index}`}
                            style={{ maxWidth: '100%', maxHeight: 'calc(100% - 20px)', objectFit: 'contain' }}
                          />
                        )}
                        {isVideo && (
                          <VideoFileIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
                        )}
                        {isLink && !isImage && !isVideo && (
                          <LinkIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
                        )}
                        {(!isImage && !isVideo && !isLink) && (
                          <ImageOutlinedIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
                        )}
                        <IconButton
                          size="small"
                          sx={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            backgroundColor: 'rgba(255, 255, 255, 0.7)',
                            '&:hover': {
                              backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            },
                            zIndex: 1,
                          }}
                          onClick={() => handleRemoveExistingMedia(url)}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                        <Typography
                          variant="caption"
                          title={url}
                          sx={{
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            backgroundColor: 'rgba(0,0,0,0.6)',
                            color: 'white',
                            px: 0.5,
                            py: 0.2,
                            fontSize: '0.6rem',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                          }}
                        >
                          {url.split('/').pop().split('?')[0] || url}
                        </Typography>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            )} */}
          </Box>
          <Divider sx={{ my: 2 }} />

        
          <Divider sx={{ my: 2 }} />
          {/* --- End PDF Files Section --- */}


          <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
            <InputLabel id="city-select-label">City</InputLabel>
            <Select
              labelId="city-select-label"
              name="city"
              value={editFormData.city || ''}
              label="City"
              onChange={handleEditFormChange}
              disabled={!editFormData.state || citiesDropdown.length === 0}
            >
              <MenuItem value="">Select City (Optional)</MenuItem>
              {citiesDropdown.map((city) => (
                <MenuItem key={city._id} value={city._id}>
                  {city.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            margin="dense"
            name="localAddress"
            label="Local Address"
            type="text"
            fullWidth
            variant="outlined"
            value={editFormData.localAddress || ""}
            onChange={handleEditFormChange}
            sx={{ mb: 2 }}
          />
          <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
            <InputLabel id="status-select-label">Status</InputLabel>
            <Select
              labelId="status-select-label"
              name="status"
              value={editFormData.status || ""}
              label="Status"
              onChange={handleEditFormChange}
            >
              <MenuItem value="draft">Draft</MenuItem>
              <MenuItem value="pending_approval">Pending Approval</MenuItem>
              <MenuItem value="posted">Posted</MenuItem>
              <MenuItem value="live">Live</MenuItem>
              <MenuItem value="rejected">Rejected</MenuItem>
            </Select>
          </FormControl>

        </DialogContent>

        <DialogActions>
          <Button onClick={handleEditClose} disabled={updating}>
            Cancel
          </Button>
          <Button
            onClick={handleUpdateSubmit}
            variant="contained"
            color="primary"
            disabled={updating}
          >
            {updating ? "Updating..." : "Save Changes"}
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog open={deleteConfirmOpen} onClose={handleDeleteCancel} maxWidth="xs" fullWidth>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent dividers>
          Are you sure you want to delete this news?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} disabled={deleting}>
            Cancel
          </Button>
          <Button
            onClick={handleDeleteConfirm}
            color="error"
            variant="contained"
            disabled={deleting}
          >
            {deleting ? "Deleting..." : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AllNewsManagement ;